<template>
  <div>
    <DialogBase
      title="Danh sách tài khoản VA"
      :visible.sync="showAccountVADialog"
      width="1350px"
      panel-icon="el-icon-bank"
      panel-title="DANH SÁCH TÀI KHOẢN ẢO (VA)"
      panel-subtitle="Danh sách các tài khoản ảo liên kết và cấu hình mã QR động cho học sinh."
      @before-close="handleClose"
      @cancel="handleClose"
    >
      <div class="dialog-content">
        <!-- Table -->
        <el-table
          ref="multipleTable"
          v-loading="loading.table"
          element-loading-text="Đang tải danh sách tài khoản ảo..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.7)"
          highlight-current-row
          :data="listVA"
          class="modern-table"
          border
          :max-height="tableMaxHeight"
        >
          <el-table-column type="index" label="STT" width="55" align="center" fixed />

          <el-table-column label="Số tài khoản ảo (VA)" prop="va" min-width="200" align="center" fixed>
            <template slot-scope="{ row }">
              <code class="code-badge-blue">{{ row.va }}</code>
            </template>
          </el-table-column>

          <el-table-column label="ID VA" prop="idVa" width="120" align="center">
            <template slot-scope="{ row }">
              <code class="code-badge">{{ row.idVa }}</code>
            </template>
          </el-table-column>

          <el-table-column label="Tên gợi nhớ" prop="label" min-width="180">
            <template slot-scope="{ row }">
              <span class="label-text">{{ row.label || '—' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Hiển thị QR" prop="showQR" align="center" width="130">
            <template slot-scope="{ row }">
              <el-checkbox
                v-model="row.showQR"
                :disabled="!row.active || !showQRMainAccount"
                @change="handleChangeShowVA(row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="Tiền vào trong tháng" prop="sumMoneyIn" align="right" min-width="180">
            <template slot-scope="{ row }">
              <span class="money-text green">{{ row.sumMoneyIn | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Tiền ra trong tháng" prop="sumMoneyOut" align="right" min-width="180">
            <template slot-scope="{ row }">
              <span class="money-text red">{{ row.sumMoneyOut | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Trạng thái" prop="active" align="center" width="160">
            <template slot-scope="{ row }">
              <span class="status-badge" :class="row.active ? 'online' : 'offline'">
                <span class="dot"></span>
                {{ row.active ? 'Hoạt động' : 'Tạm khóa' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="Tác vụ điều khiển" align="center" width="240" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                v-if="checkPermission(['bank-connection-manager-va-unlink'])"
                size="mini"
                type="danger"
                icon="el-icon-lock"
                :disabled="!row.active"
                @click="disableAccount(row.idVa)"
              >
                Khóa
              </el-button>
              <el-button
                v-if="checkPermission(['bank-connection-manager-va-link'])"
                size="mini"
                type="success"
                icon="el-icon-unlock"
                :disabled="row.active || bank.bankApiConnected === false"
                @click="enableBank(row.idVa)"
              >
                Mở khóa
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Custom footer layout to include dropdown action -->
      <template slot="footer">
        <div class="custom-footer-bar flex justify-between w-full align-center">
          <div class="footer-left">
            <el-dropdown v-if="!actionToAdmin" @command="handleCommand">
              <el-button type="success" class="gradient-btn-small green" icon="el-icon-plus">
                Tác vụ VA <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="modern-dropdown-menu">
                <el-dropdown-item v-if="checkPermission(['bank-connection-manager-va-create'])" command="addAccountBankVA" icon="el-icon-plus">
                  Thêm tài khoản ảo VA
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-else></span>
          </div>
          <div class="footer-right">
            <el-button class="btn-cancel" @click="handleClose">Đóng hộp thoại</el-button>
          </div>
        </div>
      </template>
    </DialogBase>

    <OTPAuthenticationAndVAToKienLongBankDialog
      :isOTPAuthenticationKienLongBankDialog="isOTPAuthenticationKienLongBankDialog"
      :bank="bank"
      @closeDialog="handleCloseOTPAuthenticationKienLongBankDialog"
      @closeDialogAll="handleCloseAllOTPAuthenticationKienLongBankDialog"
    />
    <OTPAuthenticationAndVAToOCBDialog
      :isOTPAuthenticationOCBDialog="isOTPAuthenticationOCBDialog"
      :bank="bank"
      @closeDialog="handleCloseOTPAuthenticationOCBDialog"
      @closeDialogAll="handleCloseAllOTPAuthenticationOCBDialog"
    />
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import OTPAuthenticationAndVAToKienLongBankDialog from "@/views/sepay/dialog/OTPAuthenticationAndVAToKienLongBankDialog.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import OTPAuthenticationAndVAToOCBDialog from "@/views/sepay/dialog/OTPAuthenticationAndVAToOCBDialog.vue";
import checkPermission from "@/utils/permission";

export default {
  name: "AccountVADialog",
  components: { DialogBase, OTPAuthenticationAndVAToOCBDialog, OTPAuthenticationAndVAToKienLongBankDialog },
  props: {
    showAccountVADialog: {
      type: Boolean,
      default: () => false
    },
    showQRMainAccount: {
      type: Boolean,
      default: () => false
    },
    listVA: {
      type: Array,
      default: () => []
    },
    bank: {
      type: Object,
      default: () => null
    },
    actionToAdmin: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      isOTPAuthenticationKienLongBankDialog: false,
      isOTPAuthenticationOCBDialog: false,
      loading: {
        table: false
      }
    };
  },
  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 600;
    }
  },
  methods: {
    checkPermission,
    handleClose() {
      this.$emit("closeDialog");
    },
    handleCloseOTPAuthenticationKienLongBankDialog() {
      this.isOTPAuthenticationKienLongBankDialog = false;
    },
    handleCloseAllOTPAuthenticationKienLongBankDialog() {
      this.isOTPAuthenticationKienLongBankDialog = false;
      this.handleClose();
    },
    handleCloseOTPAuthenticationOCBDialog() {
      this.isOTPAuthenticationOCBDialog = false;
    },
    handleCloseAllOTPAuthenticationOCBDialog() {
      this.isOTPAuthenticationOCBDialog = false;
      this.handleClose();
    },

    handleCommand(command) {
      if (command === "addAccountBankVA") {
        if (this.bank.bankName === "KienLongBank") {
          this.isOTPAuthenticationKienLongBankDialog = true;
        } else if (this.bank.bankName === "OCB") {
          this.isOTPAuthenticationOCBDialog = true;
        }
      }
    },

    disableAccount(id) {
      this.$confirm("Bạn có chắc chắn muốn vô hiệu hóa tài khoản này?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(async () => {
        try {
          if (this.bank.bankName === "KienLongBank") {
            const serviceCall = this.actionToAdmin
              ? sePayConnectionService.sendRequestDisableBankAccountVAKienLongBankByAdmin
              : sePayConnectionService.sendRequestDisableBankAccountVAKienLongBank;
            const res = await serviceCall(id);
            if (res.data.data.code === "200") {
              NotifyMessage.leftCornerNotificationSuccess(res.data.data.message);
              this.handleClose();
            } else {
              NotifyMessage.leftCornerNotificationError(res.data.data.message);
              this.handleClose();
            }
          } else if (this.bank.bankName === "OCB") {
            const serviceCall = this.actionToAdmin
              ? sePayConnectionService.sendRequestDisableBankAccountVAOCBByAdmin
              : sePayConnectionService.sendRequestDisableBankAccountVAOCB;
            const res = await serviceCall(id);
            if (res.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Vô hiệu hóa thành công!");
              this.handleClose();
            } else {
              NotifyMessage.leftCornerNotificationError("Vô hiệu hóa thất bại!");
              this.handleClose();
            }
          }
        } catch (err) {
          console.error(err);
        }
      });
    },

    enableBank(id) {
      this.$confirm("Bạn có chắc chắn muốn kích hoạt tài khoản này?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(async () => {
        try {
          if (this.bank.bankName === "KienLongBank") {
            const serviceCall = this.actionToAdmin
              ? sePayConnectionService.sendRequestEnableBankAccountVAKienLongBankByAdmin
              : sePayConnectionService.sendRequestEnableBankAccountVAKienLongBank;
            const res = await serviceCall(id);
            if (res.data.data.code === "200") {
              NotifyMessage.leftCornerNotificationSuccess(res.data.data.message);
              this.handleClose();
            } else {
              NotifyMessage.leftCornerNotificationError(res.data.data.message);
              this.handleClose();
            }
          } else if (this.bank.bankName === "OCB") {
            const serviceCall = this.actionToAdmin
              ? sePayConnectionService.sendRequestEnableBankAccountVAOCBByAdmin
              : sePayConnectionService.sendRequestEnableBankAccountVAOCB;
            const res = await serviceCall(id);
            if (res.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Kích hoạt thành công!");
              this.handleClose();
            } else {
              NotifyMessage.leftCornerNotificationError("Kích hoạt thất bại!");
              this.handleClose();
            }
          }
        } catch (err) {
          console.error(err);
        }
      });
    },

    async handleChangeShowVA(row) {
      try {
        const response = this.actionToAdmin
          ? await sePayConnectionService.showQRBankVAByAdmin(row.idVa, row.showQR, this.bank.idSchool)
          : await sePayConnectionService.showQRBankVA(row.idVa, row.showQR);
        if (response.data.data === true) {
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
          this.handleClose();
        } else {
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
          this.handleClose();
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 8px 0;
  }
}

.code-badge-blue {
  background: #eff6ff;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 13px;
  font-weight: 700;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.label-text {
  font-weight: 600;
  color: #475569;
}

.money-text {
  font-family: Consolas, Monaco, monospace;
  font-weight: 700;
  font-size: 13px;

  &.green { color: #166534; }
  &.red { color: #991b1b; }
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 9999px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.online {
    background-color: #f0fdf4;
    color: #166534;
    .dot {
      background-color: #22c55e;
    }
  }

  &.offline {
    background-color: #fef2f2;
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

.custom-footer-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.gradient-btn-small {
  border: none;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-1px);
  }

  &.green {
    background: linear-gradient(90deg, #10b981 0%, #059669 100%);
    box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
    color: #fff;
  }
}

.btn-cancel {
  border: 1px solid #cbd5e1;
  background-color: #fff;
  color: #64748b;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 8px;
  &:hover {
    background-color: #f1f5f9;
    color: #475569;
  }
}

.flex { display: flex; }
.justify-between { justify-content: space-between; }
.w-full { width: 100%; }
.align-center { align-items: center; }
</style>